import React, { useState, useEffect, useRef } from 'react';

// material ui
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import TextField from '@material-ui/core/TextField';

import useStyles from './styles';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import InfoButton from '../../../../../components/InfoButton';


function SubForm05({ id, setValue, saveValue, saveValueJump, value, kb, handleNextSub, navigationMode, handleBackSub, no_kk, isSubmitting, setKB }) {

    const nextRef = useRef(null);
    const backRef = useRef(null);

    const classes = useStyles();
    const [error, setError] = useState({});
    const [dontUseContrasep, setDontUseContrasep] = useState(false);

    const [tdkKb, setTdkKb] = useState(value.alasan_tidak_kb || '')

    const pertanyaan = "Alasan utama tidak pakai atau putus pakai kontrasepsi:";

    useEffect(() => {

        let normalizeValue = {
            _id: `${no_kk}${id}`,
            Pertanyaan: pertanyaan,
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            Jawaban_HDate1: "",
            Jawaban_HDate2: "",
            No_Pertanyaan: 5,
            No_KK: no_kk,
            answer: [
                {
                    _id: `${no_kk}${id}01`,
                    No_Jawaban: tdkKb,
                    Jawaban_D1: 0,
                    Jawaban_D2: 0,
                    Jawab_D3: 0,
                    Jawab_D4: 0,
                    pilihankb: 0,
                    Lainnya: ""
                },

            ]

        }
        if (value._rev) {
            normalizeValue._rev = value._rev
        }

        saveValueJump(normalizeValue)

    }, [tdkKb])

    useEffect(() => {
        setError({})

        // if (kb["0104"].menggunakan_kontrasepsi !== "1" && kb["0105"].pernah_menggunakan_kontrasepsi === "2" || kb["0105"].pernah_menggunakan_kontrasepsi === "1" ) {
        //     setDontUseContrasep(true);
        // } else {
        //     if (navigationMode === 'back') {
        //         handleBackSub();
        //     } else {
        //         handleNextSub()
        //     }
        // }
        /* cek kondisi untuk semua form */
        if (kb["0102"].sedang_hamil === "2" && kb["0103"].menggunakan_kontrasepsi === "2" && kb["0104"].pernah_menggunakan_kontrasepsi === "1") {
            setDontUseContrasep(true);
        } else {
            if (kb["0102"].sedang_hamil === "2" && kb["0103"].menggunakan_kontrasepsi === "1") {

                let normalizeValue = {}

                setKB({
                    ...kb,
                    [id]: {
                        ...kb[id],
                        ["alasan_tidak_kb"]: undefined
                    }
                })

                if (navigationMode === 'back') {
                    handleBackSub();
                } else {
                    saveValueJump(normalizeValue)
                    handleNextSub()
                }


            } else {
                setDontUseContrasep(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!dontUseContrasep) {
        return null
    }

    // const [dontUseContrasep, setDontUseContrasep] = useState(false);
    // useEffect(() => {
    //     setError({})

    //     if (kb["0106"].jenis_kontrasepsi !== "9") {
    //         setDontUseContrasep(true);
    //     } else {
    //         if (navigationMode === 'back') {
    //             handleBackSub();
    //         } else {
    //             handleNextSub()
    //         }
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [])

    // if (!dontUseContrasep) {
    //     return null
    // }



    const handleChange = (e) => {

        setValue(e)

        setError({
            ...error,
            [e.target.name]: ""
        })

        if (e.target.name == "alasan_tidak_kb") {
            setTdkKb(e.target.value)
        }

        // setSomethingChange(true)
    }

    const validate = () => {
        let newError = {};

        if (!value.alasan_tidak_kb) {
            newError.alasan_tidak_kb = "Wajib diisi";
        }

        // if (value.alasan_tidak_kb === "13") {
        //     if (!value.alasan_tidak_kb_lainnya) {
        //         newError.alasan_tidak_kb_lainnya = "Lainnya wajib diisi";
        //     }


        // }


        return newError;
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const findErrors = validate();

        const errorValues = Object.values(findErrors);

        if (errorValues.length > 0 && errorValues.some(err => err !== '')) {
            setError(findErrors);
        } else {

            // const normalizeValue = {
            //     pertanyaan,
            //     jawaban_1: value.alasan_tidak_kb,
            //     jawaban_2: value.alasan_tidak_kb_lainnya

            // }
            // saveValue(normalizeValue)
            let normalizeValue = {
                _id: `${no_kk}${id}`,
                Pertanyaan: pertanyaan,
                Jawaban_H1: 0,
                Jawaban_H2: 0,
                Jawaban_HDate1: "",
                Jawaban_HDate2: "",
                No_Pertanyaan: 5,
                No_KK: no_kk,
                answer: [
                    {
                        _id: `${no_kk}${id}01`,
                        No_Jawaban: value.alasan_tidak_kb,
                        Jawaban_D1: 0,
                        Jawaban_D2: 0,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: 0,
                        Lainnya: value.alasan_tidak_kb_lainnya ? value.alasan_tidak_kb_lainnya : ""
                    },

                ]

            }
            if (value._rev) {
                normalizeValue._rev = value._rev
            }

            saveValue(normalizeValue)
        }
    }

    return (
        <>
            <form id={id} onSubmit={handleSubmit} noValidate>
                <div className={classes.card}>
                    <div className={classes.cardHeader}>
                        <Typography margin="normal" paragraph>
                            <span className={classes.badge}>05</span>{pertanyaan} <strong>(pilih hanya satu jawaban)</strong></Typography>
                            <div style={{ position: "absolute", right: "0", top: "58px" }}>
                                <InfoButton
                                    content={
                                        "Alasan utama tidak pakai atau putus pakai kontrasepsi adalah alasan paling utama responden (istri atau suami) tidak menggunakan kontrasepsi."+
                                        "\nBaru melahirkan adalah seorang wanita yang tidak memiliki risiko hamil karena pasca melahirkan dan belum menstruasi."+
                                        "\n6 (enam) terakhir tidak melakukan hubungan suami istri adalah tidak melakukan hubungan suami istri selama 6 bulan atau lebih karena suami/istri tinggal jauh, jarang berhubungan, atau alasan lainnya."+
                                        "\n6 (enam) bulan terakhir tidak menstruasi adalah tidak menstruasi selama 6 bulan atau lebih dan bukan postpartum amenore."+
                                        "\nLama menikah minimal 5 tahun dan belum memiliki anak adalah lama menikah 5 tahun atau lebih, tidak pernah menggunakan KB, dan tidak pernah melahirkan anak hidup."
                                    }
                                />
                            </div>
                    </div>
                    <div className={classes.cardBody}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} >
                                <FormControl error={error.alasan_tidak_kb ? true : false} component="fieldset" fullWidth>
                                    <RadioGroup value={value.alasan_tidak_kb || ''}
                                        onChange={handleChange}
                                        aria-label="alasan_tidak_kb" name="alasan_tidak_kb"
                                        className={classes.radioGroup}
                                    >
                                        <div className={classes.radioSection}>
                                            <FormControlLabel control={<Radio />}
                                                value="1"
                                                label="1. Ingin hamil/anak" />
                                            <FormControlLabel control={<Radio />}
                                                value="2"
                                                label="2. Tidak tahu tentang KB" />
                                            <FormControlLabel control={<Radio />}
                                                value="3"
                                                label="3. Alasan kesehatan" />
                                            <FormControlLabel control={<Radio />}
                                                value="4"
                                                label="4. Efek samping/kegagalan KB" />
                                            <FormControlLabel control={<Radio />}
                                                value="5"
                                                label="5. Tempat pelayanan jauh" />
                                            <FormControlLabel control={<Radio />}
                                                value="6"
                                                label="6. Alat/obat/cara KB tidak tersedia" />
                                            <FormControlLabel control={<Radio />}
                                                value="7"
                                                label="7. Biaya mahal" />
                                            <FormControlLabel control={<Radio />}
                                                value="8"
                                                label="8. Tidak ada alat/obat/cara KB yang cocok" />
                                        </div>

                                        <div className={classes.radioSection}>
                                            <FormControlLabel control={<Radio />}
                                                value="9"
                                                label="9. Suami/keluarga menolak" />
                                            <FormControlLabel control={<Radio />}
                                                value="10"
                                                label="10. Alasan agama" />
                                            <FormControlLabel control={<Radio />}
                                                value="11"
                                                label="11. Tidak ada petugas pelayanan KB" />
                                            <FormControlLabel control={<Radio />}
                                                value="12"
                                                label="12. Baru melahirkan" />
                                            <FormControlLabel control={<Radio />}
                                                value="13"
                                                label="13. Enam bulan terakhir tidak melakukan hubungan suami istri (misal: suami jauh)" />
                                            <FormControlLabel control={<Radio />}
                                                value="14"
                                                label="14. Enam bulan terakhir tidak menstruasi" />
                                            <FormControlLabel control={<Radio />}
                                                value="15"
                                                label="15. Tidak subur/mandul/lama menikah minimal 5 tahun dan belum memiliki anak" />
                                            <FormControlLabel control={<Radio />}
                                                value="16"
                                                label="16. Menopause" />
                                            {/* {value.alasan_tidak_kb === "13" &&

                                        <TextField
                                            fullWidth

                                            placeholder="Tuliskan"
                                            variant="outlined"
                                            id="alasan_tidak_kb_lainnya"
                                            name="alasan_tidak_kb_lainnya"
                                            value={value.alasan_tidak_kb_lainnya || ''}
                                            onChange={handleChange}
                                            error={error.alasan_tidak_kb_lainnya ? true : false}
                                            helperText={error.alasan_tidak_kb_lainnya}
                                            inputProps={{
                                                className: classes.inputMini
                                            }}

                                        />} */}
                                        </div>
                                    </RadioGroup>

                                    <FormHelperText>{error.alasan_tidak_kb}</FormHelperText>
                                </FormControl>
                            </Grid>




                        </Grid>
                    </div>
                </div>
            </form>

            <Grid item xs style={{ marginTop: 20 }}>
                <Button
                    ref={backRef}
                    // disabled={!isSomethingChange || isSubmitting}
                    onClick={handleBackSub}><ChevronLeft className={classes.iconLeft} /> Sebelumnya </Button>

                {isSubmitting && <CircularProgress size={14} />}
                <Button
                    style={{ float: 'right' }}
                    ref={nextRef}
                    form={id}
                    disabled={isSubmitting}
                    type="submit">Selanjutnya <ChevronRight className={classes.iconRight} /></Button>
            </Grid>
        </>
    )
}

export default SubForm05;